(function($) {
    $(document).on('click', '[data-tncp-powerviewlink]', function () {
        if (jQuery(this).attr('data-href-set') !== '1') {
            jQuery(this).attr('data-href', jQuery(this).attr('href'));
            jQuery(this).attr('data-href-set', '1');
        }

        var filter;
        if (jQuery(this).attr('data-tncp-powerview-tab') !== '') {
            var powerviewIndex = jQuery(this).attr('data-tncp-powerview-tab');
            jQuery('[data-tncp-filter-serialized]').each(function(index) {
                if (jQuery(this).attr('data-tncp-tab') === powerviewIndex) {
                    filter = jQuery(this).val();
                }
            });
        } else if ($('[data-tncp-filter-serialized]').length > 0) {
            filter = $('[data-tncp-filter-serialized]').val();
        }

        if (!filter) {
            filter = window.location.href.split('#!/')[1];
        }

        jQuery(this).attr('href', jQuery(this).attr('data-href') + '#!/' + filter);
    });

})(jQuery);